import { isPast } from 'date-fns'

import {
  AuctionBiddingEngine,
  AuctionType,
  DateValue,
  EAuctionBiddingEngine,
  EAuctionType,
} from '@bonhams1793/bonhams-typescript'

export const canLotBeBidOn = ({
  auctionType,
  biddableFrom,
  biddingEngine,
  isExhibition,
  isPreview,
  isToBeSold,
  lotAMId,
}: {
  auctionType: EAuctionType
  biddableFrom?: Omit<DateValue, 'timestamp'> | null
  isExhibition: boolean
  isPreview: boolean
  isToBeSold: boolean
  biddingEngine: EAuctionBiddingEngine | null
  lotAMId?: string
}) => {
  const auctionIsBiddable =
    auctionType === AuctionType.online
      ? biddableFrom
        ? isPast(biddableFrom.datetime)
        : false
      : !isExhibition

  const lotIsBiddable = !isPreview && !!isToBeSold

  if (biddingEngine === AuctionBiddingEngine.AM) {
    return auctionIsBiddable && lotIsBiddable && !!lotAMId
  } else if (biddingEngine === AuctionBiddingEngine.BBE) {
    return auctionIsBiddable && lotIsBiddable
  }

  return false
}
